<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="19.25" y="10.0625" width="9.5" height="9.5" rx="1.5" stroke="var(--icon-color)" />
    <rect x="8.75" y="28.4375" width="9.5" height="9.5" rx="1.5" stroke="var(--icon-color)" />
    <rect x="29.75" y="28.4375" width="9.5" height="9.5" rx="1.5" stroke="var(--icon-color)" />
    <path d="M17.4375 16.125H14.1875C13.0829 16.125 12.1875 17.0204 12.1875 18.125V26.625" stroke="var(--icon-color)" />
    <path d="M30.5625 16.125H33.8125C34.9171 16.125 35.8125 17.0204 35.8125 18.125V26.625" stroke="var(--icon-color)" />
    <path d="M27.9375 33.1875L20.0625 33.1875" stroke="var(--icon-color)" />
</svg>
